import { orderBy } from 'lodash-es';
import { Accounting } from '~/types/accounting';
export const CONTACT_COLUMN_NAMES = [
    'companyName',
    'status',
    'primaryContactName',
    'contactDetails'
];
export const DEFAULT_CONTACTS_SORT = {
    name: 'companyName',
    direction: 'desc'
};
export const CONTACT_ROW_HEAP_ID = 'contact';
export const SAMPLE_CONTACT_ROW_HEAP_ID = 'sample-contact';
export const contactRowHeapId = (row, sampleIds)=>sampleIds.has(row.id) ? SAMPLE_CONTACT_ROW_HEAP_ID : CONTACT_ROW_HEAP_ID;
export const CONTACT_MENU_LABELS = {
    delete: 'Delete'
};
const ACCOUNTING_FULL_NAME = {
    qbo: 'QuickBooks Online',
    xero: 'Xero'
};
export const integrationTooltipText = (entry)=>entry.status === 'success' ? "Mapped in ".concat(ACCOUNTING_FULL_NAME[entry.provider]) : "Missing ".concat(ACCOUNTING_FULL_NAME[entry.provider], " mapping");
export const accountingDisplay = (param)=>{
    let { contact, accounting, displayById } = param;
    const integratedId = contact.integratedId({
        accounting
    });
    return integratedId == null ? undefined : displayById[integratedId];
};
const accountingIntegrations = (param)=>{
    let { contact, showQbo, showXero, qboDisplayById, xeroDisplayById } = param;
    const entry = (accounting, displayById)=>({
            provider: accounting === Accounting.QBO ? 'qbo' : 'xero',
            status: accountingDisplay({
                contact,
                accounting,
                displayById
            }) == null ? 'pending' : 'success'
        });
    return [
        ...showQbo ? [
            entry(Accounting.QBO, qboDisplayById)
        ] : [],
        ...showXero ? [
            entry(Accounting.Xero, xeroDisplayById)
        ] : []
    ];
};
export const toContactRows = (param)=>{
    let { contacts, statusTexts, showQbo = false, showXero = false, qboDisplayById = {}, xeroDisplayById = {} } = param;
    return contacts.map((contact)=>{
        var _contact_phone;
        return {
            id: contact.id(),
            companyName: contact.companyName(),
            status: statusTexts[contact.status()](),
            primaryContactName: contact.fullName(),
            contactDetails: contact.email(),
            phone: (_contact_phone = contact.phone()) !== null && _contact_phone !== void 0 ? _contact_phone : '',
            integrations: accountingIntegrations({
                contact,
                showQbo,
                showXero,
                qboDisplayById,
                xeroDisplayById
            })
        };
    });
};
export const filterContacts = (param)=>{
    let { contacts, search, statuses } = param;
    const trimmedSearch = search.trim().toLowerCase();
    return contacts.filter((contact)=>{
        const searchable = "".concat(contact.companyName(), " ").concat(contact.firstName(), " ").concat(contact.lastName(), " ").concat(contact.email());
        return searchable.toLowerCase().includes(trimmedSearch) && statuses.includes(contact.status());
    });
};
const sortPropertiesByColumn = {
    companyName: [
        (contact)=>contact.companyName()
    ],
    status: [
        (contact)=>contact.status(),
        (contact)=>contact.companyName()
    ],
    primaryContactName: [
        (contact)=>contact.firstName(),
        (contact)=>contact.lastName(),
        (contact)=>contact.companyName()
    ],
    contactDetails: [
        (contact)=>contact.email(),
        (contact)=>contact.companyName()
    ]
};
export const sortContacts = (param)=>{
    let { contacts, sort } = param;
    var _sortPropertiesByColumn_sort_name;
    const properties = (_sortPropertiesByColumn_sort_name = sortPropertiesByColumn[sort.name]) !== null && _sortPropertiesByColumn_sort_name !== void 0 ? _sortPropertiesByColumn_sort_name : sortPropertiesByColumn.companyName;
    const direction = sort.direction === 'asc' ? 'desc' : 'asc';
    return orderBy(contacts, properties, properties.map(()=>direction));
};
export const contactColumns = (param)=>{
    let { texts, integrationTooltip } = param;
    return {
        mainColumn: {
            type: 'text',
            name: 'companyName',
            header: texts.clientName(),
            width: {
                initial: 170,
                min: 170
            },
            weight: 'normal',
            sortable: true,
            bi: {
                name: 'contacts_by_company_name'
            },
            integrations: (row)=>row.integrations,
            integrationIcon: 'mapping',
            integrationTooltip
        },
        columns: [
            {
                type: 'text',
                name: 'status',
                header: texts.status(),
                width: {
                    initial: 140,
                    min: 140
                },
                weight: 'normal',
                sortable: true,
                bi: {
                    name: 'contacts_by_status'
                }
            },
            {
                type: 'text',
                name: 'primaryContactName',
                header: texts.contactName(),
                width: {
                    initial: 180,
                    min: 180
                },
                sortable: true,
                bi: {
                    name: 'contacts_by_primary_contact_name'
                }
            },
            {
                type: 'text',
                name: 'contactDetails',
                header: texts.contactDetails(),
                width: {
                    initial: 220,
                    min: 220
                },
                subtitle: (row)=>[
                        row.phone
                    ],
                sortable: true,
                bi: {
                    name: 'contacts_by_contact_details'
                }
            }
        ]
    };
};
